/* ============================================================
   LB POLISH — El Laboratorio del Bazar
   Reveals al hacer scroll + fade de imagenes diferidas.
   Adaptado de elegance-animations.js de la skill, con tres arreglos:

     1. Marca <html class="lb-js"> de inmediato. El CSS solo esconde cosas
        si esta marca existe, asi que si este archivo no carga, la pagina se
        ve completa en vez de quedar en blanco.
     2. MutationObserver: las imagenes que aparecen despues (modales,
        busqueda, apps) tambien reciben el fade. Antes se quedaban invisibles.
     3. Red de seguridad por tiempo: a los 3 segundos, cualquier imagen que
        siga sin resolverse se muestra igual. Nunca una imagen invisible.
   ============================================================ */

(function () {
  'use strict';

  // 1. Avisar cuanto antes que el JS esta vivo (el CSS depende de esto).
  document.documentElement.classList.add('lb-js');

  // ---------- Aparicion al hacer scroll ----------
  function observarReveals(raiz) {
    var elementos = (raiz || document).querySelectorAll('[data-lb-reveal]:not(.lb-in-view)');
    if (!elementos.length) return;

    if (!('IntersectionObserver' in window)) {
      elementos.forEach(function (el) { el.classList.add('lb-in-view'); });
      return;
    }

    var observador = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (entrada) {
        if (entrada.isIntersecting) {
          entrada.target.classList.add('lb-in-view');
          observador.unobserve(entrada.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -50px 0px' });

    elementos.forEach(function (el) { observador.observe(el); });
  }

  // ---------- Fade de imagenes diferidas ----------
  function marcarCargada(img) {
    img.classList.add('lb-loaded');
  }

  function prepararImagenes(raiz) {
    var imgs = (raiz || document).querySelectorAll('img[loading="lazy"]:not(.lb-loaded)');
    imgs.forEach(function (img) {
      if (img.complete) {
        marcarCargada(img);
        return;
      }
      img.addEventListener('load', function () { marcarCargada(img); }, { once: true });
      // Si falla, se muestra igual: mejor el icono roto que un hueco invisible.
      img.addEventListener('error', function () { marcarCargada(img); }, { once: true });
    });
  }

  // ---------- Marquee: duplicar la pista para que el loop sea continuo ----------
  function prepararMarquee(raiz) {
    var marquees = (raiz || document).querySelectorAll('[data-lb-marquee]');
    marquees.forEach(function (m) {
      var pista = m.querySelector('[data-marquee-track]');
      if (!pista || pista.dataset.duplicada === '1') return;
      var copia = pista.cloneNode(true);
      copia.setAttribute('aria-hidden', 'true');
      pista.parentNode.appendChild(copia);
      pista.dataset.duplicada = '1';
    });
  }

  function iniciar(raiz) {
    observarReveals(raiz);
    prepararImagenes(raiz);
    prepararMarquee(raiz);
  }

  // 2. Contenido que llega despues (modales, busqueda, apps).
  function vigilarNuevoContenido() {
    if (!('MutationObserver' in window)) return;
    var vigilante = new MutationObserver(function (mutaciones) {
      mutaciones.forEach(function (m) {
        m.addedNodes.forEach(function (nodo) {
          if (nodo.nodeType !== 1) return;
          if (nodo.tagName === 'IMG') {
            prepararImagenes(nodo.parentNode || document);
          } else {
            iniciar(nodo);
          }
        });
      });
    });
    vigilante.observe(document.documentElement, { childList: true, subtree: true });
  }

  // 3. Red de seguridad: nada se queda invisible por un evento perdido.
  function redDeSeguridad() {
    setTimeout(function () {
      document.querySelectorAll('img[loading="lazy"]:not(.lb-loaded)').forEach(marcarCargada);
      document.querySelectorAll('[data-lb-reveal]:not(.lb-in-view)').forEach(function (el) {
        var caja = el.getBoundingClientRect();
        if (caja.top < window.innerHeight) el.classList.add('lb-in-view');
      });
    }, 3000);
  }

  function arrancar() {
    iniciar(document);
    vigilarNuevoContenido();
    redDeSeguridad();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  // Re-aplicar cuando el editor de temas recarga una seccion.
  document.addEventListener('shopify:section:load', function (e) {
    iniciar(e.target || document);
  });
})();
